import type { ImagemCardProps } from "./types-imagem-card";
import { useImagemCard } from "./use-imagem-card";
import { ImagemCardView } from "./view-imagem-card";

export function ImagemCard(props: ImagemCardProps) {
  const vm = useImagemCard(props);

  return <ImagemCardView {...vm} />;
}

export type * from "./types-imagem-card";
